// Package imports:
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/pro-solid-svg-icons';
// Component imports:
import Alert from '../../../ui-elements/Alert/Alert';
import Link from '../../../ui-elements/Link/Link';
import DisplayBox from '../../DisplayBox/DisplayBox';
import Fyrirvari from '../../Fyrirvari/Fyrirvari';
import Label from '../../../ui-elements/Label/Label';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { Fetched } from '../../../types/Types';
import { IKeldanApiResponse } from '../../../types/KeldanTypes';
import { IAuthenticationWithIdAndEventId, IViewCompanyCompare } from '../../../types/CompanyTypes';
import ViewCompanyCompareBody from './ViewCompanyCompareBody';

const ViewCompanyCompare: React.FC<IAuthenticationWithIdAndEventId> = ({
    id,
    eventId,
}) => {
    const [data, setData] = useState<Fetched<IViewCompanyCompare>>(null);

    const [ disclaimerOpen, setDisclaimerOpen ] = useState(false);
    const openDisclaimer = () => setDisclaimerOpen(true);
    const closeDisclaimer = () => setDisclaimerOpen(false);

    const fetchData = async () => {
        try {
            const url =  `${GET_KELDAN_API_URL()}/Company/GetViewComparisonData/?id=${id}&eventId=${eventId}`
            const headers = {
                'Content-Type': 'application/json; charset=utf-8'
            };
            
            const response = await fetch(url, {
                method: 'GET',
                headers
            });
            if (response.ok) {
                if (response.redirected) {
                    window.location.href = response.url;
                }
                const responseBody: IKeldanApiResponse<Fetched<IViewCompanyCompare>> = await response.json();
                if (responseBody.success) {
                    if(responseBody.result) {
                        setData(responseBody.result);
                    }
                } else {
                    const { message } = responseBody; 
                    if (message) {
                        setData(new Error(message));
                    } else {
                        setData(new Error(ErrorMessages.ErrorInRequest));
                    }
                }
            } else {
                setData(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setData(new Error(ErrorMessages.NetworkError));
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        (data instanceof Error)
            ? <DisplayBox
                className='KCL_company-viewCompare'
                title="Rekstur"
                asideComponent={<>
                    <Link url={`/Excel/CompanyCompare?ssn=${id}&eventId=${eventId}`}>
                        {<FontAwesomeIcon icon={faFileExcel} />}Gögn í Excel</Link>
                    <span className="label-wrapper" onClick={openDisclaimer}>
                        <Label text="Fyrirvari" labelType="disclaimer" />
                    </span>
                    <Fyrirvari show={disclaimerOpen} close={closeDisclaimer}>
                        <p>
                            Keldan vinnur gögn úr opinberum upplýsingum eftir bestu getu. 
                            Keldan ber ekki ábyrgð á röngum upplýsingum sem geta komið til vegna innsláttarvillna eða annarra þátta.
                            Ábendingar um villur eða rangar upplýsingar eru vel þegnar með tölvupósti á <Link linkSize='18' url='mailto:help@keldan.is'>help@keldan.is.</Link>
                        </p>
                    </Fyrirvari>
                </>}
            >
                <Alert type='error' headText={data.message} />
            </DisplayBox>
            : <ViewCompanyCompareBody
                id={id}
                eventId={eventId}
                data={data}
            />
    );
}

export default ViewCompanyCompare;